import React from 'react';
import {observer} from 'mobx-react';
import ClientProfileContainer from '../../ClientProfileContainer';
import TaxableBenefitsContainerWithState from './TaxableBenefitsContainerWithState';
import {Switch, Route} from 'react-router-dom';
import {BenefitDivisionForm} from 'taxable_benefits/components/divisions';
import {TaxableBenefitFlow} from 'taxable_benefits/components/configuration';

const TaxableBenefitProfileContainer = observer(({match, history, parentState}) => {
  return (
    <ClientProfileContainer {...{match, history, parentState}}>
      <TaxableBenefitsContainerWithState {...{match, history, parentState}}/>
    </ClientProfileContainer>
  );
});

const TaxableBenefitsContainer = observer(({match, history, parentState}) => {
  const backPath = match.url;

  return (
    <Switch>
      <Route exact path={`${match.url}/`} 
        render={({match, history}) => <TaxableBenefitProfileContainer {...{match, history, parentState}} />}/>
      <Route path={`${match.url}/benefit_divisions/:benefitDivisionId`} 
        render={({match, history}) => <BenefitDivisionForm {...{backPath, match, history}}/>} />
      <Route path={`${match.url}/:benefitClassId/rates`} 
        render={({match, history}) => <TaxableBenefitFlow {...{backPath, match, history}}/>} />
      <Route path={`${match.url}/:benefitClassId/rates/:groupBenefitCoverageId`} 
        render={({match, history}) => <TaxableBenefitFlow {...{backPath, match, history}}/>} />
    </Switch>
  );
});

export default TaxableBenefitsContainer;
